import * as React from "react";
import { ReactifySearchLiquidFactory, Sensors, SortBy, Filters, Results } from "@usereactify/search";
import { MainCollection } from "../collection/components/MainCollection";
import config from "@app/config";
import { createRoot } from "react-dom/client";

if (window.location.pathname.startsWith("/collection") && !window.location.pathname.includes("/products/")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    ...config.reactify,
    mode: "collection",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const root = createRoot(ReactifySearchMountNode!);

  root.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <MainCollection />
      </ReactifySearchProvider>
    </React.StrictMode>
  );
}
